export default __webpack_public_path__ + "static/media/allgemein_60.b8429e6f.jpg";